import { Box, Image } from '@chakra-ui/react';

const ExploreLandingPage = ({ hideText }: { hideText?: boolean }) => {
  return (
    <>
      <Box className="not-found-box" id="not-found-section">
        <Image src="/images/ui/not-found-icon.png"></Image>
        {!hideText && (
          <>
            <p className="not-found-box__title">No FFL Dealers found</p>
            <p className="not-found-box__message">
              Try adjusting your search or filter to find what you’re looking
              for
            </p>
          </>
        )}
      </Box>
    </>
  );
};

export default ExploreLandingPage;
